import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Time")
], -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Client", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Inspector")
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Property")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "mr-4"
}
const _hoisted_13 = {
  key: 1,
  class: "mr-4"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Notes", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 3 }

import { computed, PropType, inject, ref } from 'vue';
  import _get from 'lodash/get';
    import { useStore } from 'vuex';
  import { Booking } from '@/models';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'RevisitDetail',
  props: {
    booking: { type: Booking },
    leadbooking: { type: Booking },
  },
  setup(__props) {

  const actProperty: any = inject('actProperty');
  
  const props = __props;
  const showfull = ref(false);
  const store = useStore();
  const cognitoUser = computed(() => store.getters['auth/cognitoUser']);
  const dictionary = computed(() => store.getters['dictionary/current']);
  const internaljobtypedisplayname = computed((): Map<string, string> => store.getters['diary/internaljobtypedisplayname']);
  const isDiaryUser = computed(() => {
    const assignedGroups = _get(cognitoUser.value, 'signInUserSession.accessToken.payload["cognito:groups"]', []);
    return assignedGroups.some((group: string) => group === "DiaryUser");
  });
  const pischeduler = computed(() => screen.width <= 760 && isDiaryUser.value);
  
  function onAddressclick() {
    if (pischeduler.value) {
      const address = actProperty.formatAddress(props.booking?.address, ", ");
      window.open(`http://maps.google.com/?q=${encodeURIComponent(address)}`, '_blank', 'noreferrer');
    }
  }
  
  const propertyspec = computed(() => {
    let lines = [];
    const spec = props.leadbooking?.propertyspec;
    if (spec?.bedrooms) lines.push(`${spec.bedrooms} bedrooms`);
    if (spec?.bathrooms) lines.push(`${spec.bathrooms} bathrooms`);
    if (spec?.receptions) lines.push(`${spec.receptions} receptions`);
    if (spec?.other) lines.push(`${spec?.other} other`);
    return lines.join(", ");
  });
  
  const customLabelForInternaljobtype = (internaljobtype: string): string => {
    return actProperty.customLabelForInternaljobtype(internaljobtypedisplayname.value, internaljobtype)
  }

  const init = (showfullFlag: boolean) => {
    showfull.value = showfullFlag;
  };
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      (__props.booking?.startdate || __props.booking?.enddate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.booking.starttime) + " to " + _toDisplayString(__props.booking.endtime), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", { class: "mt-4" }, [
        _createElementVNode("h3", {
          class: "mb-0",
          onClick: onAddressclick
        }, "Address")
      ]),
      _createElementVNode("div", { onClick: onAddressclick }, _toDisplayString(_unref(actProperty).formatAddress(__props.booking?.address, ", ")), 1)
    ]),
    _createElementVNode("div", null, [
      (__props.booking?.customer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (__props.booking?.customer &&
        (__props.booking.customer.companyName || __props.booking.customer.branchName)
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.booking.customer.companyName) + " - " + _toDisplayString(__props.booking.customer.branchName), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.booking.subtype != 'Prep')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          (__props.booking?.inspector)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(__props.booking.inspector.name), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.leadbooking?.propertyspec)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", null, [
            (__props.leadbooking.propertyspec.propertytype)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Property type: " + _toDisplayString(__props.leadbooking.propertyspec.propertytype), 1))
              : _createCommentVNode("", true),
            (__props.leadbooking.propertyspec.furnished)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Furnished: " + _toDisplayString(__props.leadbooking.propertyspec.furnished), 1))
              : _createCommentVNode("", true),
            (propertyspec.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(propertyspec.value), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.booking.pinotes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
      : _createCommentVNode("", true),
    (__props.booking.pinotes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(__props.booking.pinotes), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})